import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Link, useParams } from 'react-router-dom';
import { css } from '@emotion/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import DealDashboardComponent from './DealDashboardComponent';

const DealDashboard = () => {
  const { authStore, dataStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [deal, setDeal] = useState(null);
  const [mappedInvoices, setMappedInvoices] = useState(null);
  const { dealID } = useParams();

  const { contactArray, transactionCategoryArray } = dataStore;

  const getDeal = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/deal/${dealID}`,
      );
      setDeal(data);
    } catch (e) {
      console.error(e);
    }
  };

  const getDealMappedInvoices = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/deal-mapped-invoices/${dealID}`,
      );
      setMappedInvoices(data);
    } catch (e) {
      console.error(e);
    }
  };

  const initialize = async () => {
    const requests = [getDeal(), getDealMappedInvoices()];
    if (contactArray.length === 0) {
      requests.push(dataStore.retrieveContacts());
    }
    if (transactionCategoryArray.length === 0) {
      requests.push(dataStore.retrieveTransactionCategories());
    }
    await Promise.all(requests);
    setLoading(false);
  };
  useEffect(() => {
    initialize();
  }, []);

  if (isLoading) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <DealDashboardComponent
              deal={deal}
              mappedInvoices={mappedInvoices}
              refreshDeal={getDeal}
              reinitialize={initialize}
            />
          </FlexDiv>
        );
      }}
    />
  );
};

export default DealDashboard;
